const order = {
    /** @type {ReturnType<typeof setTimeout> | null} */
    poll_paid_timer: null,

    /**
     * Invoke a callback if it is a function.
     *
     * @param {((...args: any[]) => void) | null} callback - The callback to invoke, or null.
     * @param {any} args - The arguments to pass to the callback.
     * @returns {void}
     */
    triggerCallback(callback, args) {
        if (typeof callback === "function") {
            callback(args);
        }
    },

    /**
     * Clear the current poll timer.
     *
     * @returns {void}
     */
    clearPollTimer() {
        if (order.poll_paid_timer !== null) {
            clearTimeout(order.poll_paid_timer);
        }
    },

    /**
     * Poll order status at a given interval until an accepted status is reached.
     *
     * @param {number | string} id - The order ID to poll.
     * @param {number} interval - Polling interval in milliseconds.
     * @param {string[]} accepted_status_array - Array of statuses that indicate completion.
     * @param {((response: any) => void) | null} callback_waiting - Callback invoked while still waiting.
     * @param {((response: any) => void) | null} callback_paid - Callback invoked when an accepted status is reached.
     * @returns {void}
     */
    pollStatus(
        id,
        interval,
        accepted_status_array,
        callback_waiting,
        callback_paid,
    ) {
        order.clearPollTimer();

        order.poll_paid_timer = setTimeout(
            () => {
                order.getStatus(
                    id,
                    (response) => {
                        order.clearPollTimer();
                        if (accepted_status_array.includes(response.status)) {
                            order.triggerCallback(callback_paid, response);
                        } else {
                            order.triggerCallback(callback_waiting, response);
                            order.pollStatus(
                                id,
                                interval,
                                accepted_status_array,
                                callback_waiting,
                                callback_paid,
                            );
                        }
                    },
                    (e) => {
                        order.clearPollTimer();
                    },
                );
            },
            interval,
            id,
            interval,
            accepted_status_array,
            callback_waiting,
            callback_paid,
        );
    },

    /**
     * Fetch order status once via AJAX.
     *
     * @param {number | string} id - The order ID to check.
     * @param {(response: any) => void} success - Success callback.
     * @param {(error: any) => void} fail - Failure callback.
     * @returns {void}
     */
    getStatus(id, success, fail) {
        const url = `/ajax/order/${id}/status`;

        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        `Request failed with status ${response.status}`,
                    );
                }

                return response.json();
            })
            .then((response) => {
                order.triggerCallback(success, response);
            })
            .catch((e) => {
                order.triggerCallback(fail, e);
            });
    },
};
window.order = order;

export {};
